//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentPlansDeliverySettings', {
//        templateUrl: 'views/components/views/consignmentPlansDeliverySettings/consignmentPlansDeliverySettings.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'consignmentPlansDeliverySettingsService', 'rememberService', function (stateService, consignmentPlansDeliverySettingsService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                edit: {},
//                selectListPortalUsers: [],
//                selectListStockLocations: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await consignmentPlansDeliverySettingsService.getEdit());
//            }

//            async function loadUsers() {
//                vm.model.selectListPortalUsers = await consignmentPlansDeliverySettingsService.listUsers();
//            }

//            async function loadStockLocations() {
//                vm.model.selectListStockLocations = await consignmentPlansDeliverySettingsService.listStockLocations();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE FUNCTION

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                Promise.all([
//                    rememberService.remember('consignmentplansdelivery.portal_user_keyno', vm.model.edit.portal_user_keyno),
//                    rememberService.remember('consignmentplansdelivery.stocklocation_keyno', vm.model.edit.stocklocation_keyno)
//                ]).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                    Promise.resolve();
//                });
//            }

//            // #endregion BUTTON SAVE FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadEdit();
//                loadUsers();
//                loadStockLocations();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
